/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useMemo } from 'react';
import { useGetShelfPageRecords } from '@/features/shelf/hooks/useGetShelfPageRecords';
import { useProductList } from '@/features/shelf/context/useProductList';
import { useContentStackPLPData } from '@/features/productListingPage/api/getContentStackProductListingPageData';
import { getCSPLPResultList } from '../utils/getCSPLPResultList';

export const useCMSShelfPageConfig = () => {
  const { data: plpCMSData } = useContentStackPLPData({
    enabled: true,
  });
  const csResultList = useMemo(() => getCSPLPResultList(plpCMSData), [plpCMSData]);

  const { data: shelfData } = useProductList();

  const pageRecData = useGetShelfPageRecords(shelfData?.shelfPageBody);
  const totalRecs = pageRecData?.totalNumRecs ?? 0;
  const firstRecNum = pageRecData?.firstRecNum ?? 0;
  const rppOptions = csResultList?.records_per_page_dropdown;

  const recordsPerPage = 24;

  return {
    recordsPerPage,
    totalRecs,
    firstRecNum,
    rppOptions,
    disableRecordsPerPage: csResultList?.disable_items_per_page ?? false,
  };
};
